import React from 'react'
import * as fb from '../../Firebase/auth'
import { EMAIL_VERIF_PERIOD } from '../../config/account'
import FormFirst from '../UserForms/FormFirst'
import FormLogin from '../UserForms/FormLogin'
import FormError from '../UserForms/FormError'
import Loader from '../Controls/Loader'

const PAGES = {
  FIRST: 1,
  CREATE_ACCOUNT: 2,
  LOGIN: 3,
  ERROR: 4
}

let missing

const validate = (what, value) => {
  if (!value) {
    missing.push(what)
    return false
  }
  return true
}

class Login extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activePage: PAGES.FIRST,
      busy: false,
      errorInfo: null,
      prevPage: 0,
      name: null,
      email: null,
      password: null,
      passwordC: null
    }
    this.go = this.go.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.handleSuccessLogin = this.handleSuccessLogin.bind(this)
    this.handleResetPassword = this.handleResetPassword.bind(this)
    this.handleError = this.handleError.bind(this)
    this.handleErrorSubmit = this.handleErrorSubmit.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.emailUnverified) {
      this.setState({
        busy: false,
        activePage: PAGES.FIRST
      })
      return
    }
    if (nextProps.login) {
      this.props.goTo('/db')
    }
  }
 

  go (page) {
    this.setState({
      activePage: page,
      busy: false
    })
  }

  handleCreate (name, email, password, passwordC, agreement) {
    missing = []
    validate('e-mail', email)
    validate('heslo', password)
    validate('potvrzení hesla', passwordC)
    if (missing.length !== 0) {
      alert('Zadejte prosím požadované údaje: ' + missing.join(', '))
      return
    }
    if (password !== passwordC) {
      alert('Hesla se neshodují.')
      return
    }
    this.props.onCreateUser(true)
    this.setState({
      busy: true,
      name: name,
      email: email,
      password: password,
      passwordC: passwordC,
      prevPage: PAGES.CREATE_ACCOUNT
    })
    fb.create(email, password, agreement, (userInfo) => {
      fb.updateUserName(name, () => {
        this.setState({
          busy: false
        })
        this.props.onCreateUser(false)
        this.props.onAuthStateChanged(userInfo)
        this.props.onUpdateName(name)
        fb.sendEmail( () => {
          alert(`Na adresu ${email} byl zaslán ověřovací e-mail.`)
          window.setTimeout(() => {
            fb.reload((emailVerified) => {
              if (!emailVerified) {
                this.props.onEmailExpiration()
              }
            })
          }, EMAIL_VERIF_PERIOD)
        }, this.handleError)
      }, this.handleError)
    }, this.handleError)
  }

  handleLogin (name, email, password) {
    this.setState({
      busy: true,
      name: name,
      email: email,
      password: password,
      prevPage: PAGES.LOGIN
    })
    fb.login(email, password, this.handleSuccessLogin, this.handleError)
  }

  handleSuccessLogin (userInfo) {
    this.props.onAuthStateChanged(userInfo)
  }

  handleResetPassword (email) {
    this.setState({
      busy: true,
      prevPage: PAGES.LOGIN
    })
    fb.sendResetPasswordEmail(email, () => {
      alert(`Na adresu ${email} byl odeslán e-mail pro obnovení heslaX.`)
    }, this.handleError)
  }

  handleError (error) {
    this.setState({
      busy: false,
      errorInfo: error
    })
    this.go(PAGES.ERROR)
  }

  handleErrorSubmit () {
    this.go(this.state.prevPage)
  }

  render () {
    if (this.state.busy) {
      return <Loader />
    }
    const p = PAGES
    let form
    const inputs = (({name, email, password, passwordC}) => ({name, email,
      password, passwordC}))(this.state)
    switch (this.state.activePage) {
      case p.FIRST:
        form = <FormFirst onCreate={() => this.go(p.CREATE_ACCOUNT)}
          onLogin={() => this.go(p.LOGIN)} />
        break
      case p.CREATE_ACCOUNT:
        form = <FormLogin register onSubmit={this.handleCreate} {...inputs}
          onCancel={() => this.go(p.FIRST)} />
        break
      case p.LOGIN:
        form = <FormLogin onSubmit={this.handleLogin} {...inputs}
          onPasswordReset={this.handleResetPassword}  onCancel={() => this.go(p.FIRST)} />
        break
      case p.ERROR:
        form = <FormError errorInfo={this.state.errorInfo} onSubmit={this.handleErrorSubmit} />
        break
      default:
        form = null
    }
    return (
      <div>
        {form}
      </div>
    )
  }
}

export default Login




// WEBPACK FOOTER //
// ./src/components/UserLogin/indexC.js